import React, { useEffect, useState,useRef } from "react";
import Modal from "react-bootstrap/Modal";
import Custompagenation from "../Customcomponents/Custompagenation";
import close_icon from "../assets/img/close.svg";
// import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import ListGroup from "react-bootstrap/ListGroup";
import Row from "react-bootstrap/Row";
import cancel, { ReactComponent as DeleteIcon } from "../assets/img/delete.svg";
import { ReactComponent as EditIcon } from "../assets/img/edit.svg";

import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import { styled } from "@mui/material/styles";
import { toast } from "react-toastify";
import Custombuttons from "../Customcomponents/Custombuttons";
import Customsearch from "../Customcomponents/Customsearch";
import DocumentViewModal from "../Customcomponents/DocumentViewModal";
import {
  getSubCategories,
  getSubcontractor,
  getSubcontractor_type,
  postDrivem,
  postSubcontractor,
} from "../api/service";
import { ReactComponent as Add } from "../assets/img/add.svg";
import { ReactComponent as ViewIcon } from "../assets/img/view.svg";
import { getIds, isMobileNumValid } from "../components/utils";

const LightTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "#008080",
    color: "#fff",
    boxShadow: theme.shadows[1],
    fontSize: 11,
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: "#008080",
  },
}));

const CENTRE_OPTIONS = [
  { value: "bangalore", label: "Bangalore" },
  { value: "delhi", label: "Delhi" },
  { value: "mumbai", label: "Mumbai" },
  { value: "hyderabad", label: "Hyderabad" },
];

const Subcontractorslist = () => {
  const [tableData, setTableData] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [selectSubContractor, setSelectedSubContractor] = useState(null);
  const [subContractorTypes, setSubContractorTypes] = useState([]);

  const [contractorsCategory, setContractorsCategory] = useState(null);

  const [show, setShow] = useState(false);

  const handleClose = () => {
    setIsEditing(null);
    setSelectedSubContractor(null);
    setShow(false);
  };
  const handleShow = () => setShow(true);
  const [deleteshow, setDeleteShow] = useState(false);
  const handleDeleteClose = () => setDeleteShow(false);
  const handleDeleteShow = () => setDeleteShow(true);
  const [searchValue, setSearchValue] = useState("");
  const [centreFilter, setCentreFilter] = useState("");
  const [typeFilter, setTypeFilter] = useState("");
  const currentUserRole = localStorage.getItem("role");
  const showAddSubConList = currentUserRole === "civil_head";
  const deleteButtonRef = useRef(null); // Reference to the delete button

  const handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      event.preventDefault(); // Prevent form submission
      deleteButtonRef.current.click(); // Trigger click event on the delete button
    }
  };

  useEffect(() => {
    if (deleteshow) {
      document.addEventListener('keydown', handleKeyPress);
      // Set focus on the delete button when the modal is shown
      deleteButtonRef.current.focus();
    } else {
      document.removeEventListener('keydown', handleKeyPress);
    }
    
    return () => {
      document.removeEventListener('keydown', handleKeyPress);
    };
  }, [deleteshow]); // Run effect when deleteshow changes


  //api call
  function apiCall() {
    getSubcontractor({
      active: "True",
      search: searchValue,
      category__supplier_type: "subcontractor",
      centre: centreFilter,
      category: typeFilter,
    })
      .then((res) => {
        setTableData(res);
      })
      .catch((err) => {
        toast.error(err.message);
      });
  }
  function getSubContractorTypes() {
    getSubcontractor_type({ pagination: false })
      .then((res) => {
        setSubContractorTypes(res);
      })
      .catch((err) => {
        toast.error(err.message);
      });
  }

  function getCategoryAndSubCategory() {
    getSubCategories({ category__name: "SubContractor" })
      .then((res) => {
        if (res?.results.length > 0) {
          setContractorsCategory(res.results);
        } else {
          toast.error("Add Task and Task History in admin panel");
        }
      })
      .catch((err) => {
        toast.error(err.message);
      });
  }
  useEffect(() => {
    apiCall();
    getSubContractorTypes();
    getCategoryAndSubCategory();
  }, []);

  //api call for on search input
  useEffect(() => {
    apiCall();
  }, [searchValue, centreFilter, typeFilter]);

  //modal for add,view,edit subcontractors
  function AddSubContractorModal() {
    // aadhar or pan card image links
    const [fileLinks, setFileLinks] = useState(null);
    const [showDoc, setShowDoc] = useState(false);

    const [isSubmitted, setIsSubmitted] = useState(false);

    const [payload, setPayload] = useState({
      id: selectSubContractor?.id,
      name: selectSubContractor?.name ?? "",
      phone: selectSubContractor?.phone ?? "",
      address: selectSubContractor?.address ?? "",
      description: selectSubContractor?.description ?? "",
      category: selectSubContractor?.category?.id ?? "",
      centre: selectSubContractor?.centre ?? "",
    });

    function getFileByType(type) {
      for (let index = 0; index < selectSubContractor?.docs.length; index++) {
        if (selectSubContractor.docs[index].sub_category === type) {
          return selectSubContractor.docs[index];
        }
      }
    }

    const [aadharFile, setAadharFile] = useState(getFileByType("Aadhar"));
    const [panFile, setPanFile] = useState(getFileByType("Pan"));

    //updating fields
    function handleInputChange(event) {
      let name = event.target.name;
      let value = event.target.value;
      setPayload({ ...payload, [name]: value });
    }

    async function uploadFile(currentFile, index) {
      let form = new FormData();
      form.append("file", currentFile);
      form.append("categories", contractorsCategory?.[index].category?.id);
      form.append("subcategories", contractorsCategory?.[index].id);
      return await postDrivem(form);
    }

    async function handleSubmitForm(event) {
      event.preventDefault();
      if (payload.name === "") {
        toast.error("Please enter name");
        return;
      } else if (!isMobileNumValid(payload.phone)) {
        toast.error("Please enter valid number");
        return;
      } else if (payload.category === "") {
        toast.error("Please select the subcontractor type");
        return;
      } else if (payload.centre === "") {
        toast.error("Please select the centre");
        return;
      } else if (payload.address === "") {
        toast.error("Please add Address");
        return;
      } else if (payload.description === "") {
        toast.error("Please enter description");
        return;
      } else if (!aadharFile) {
        toast.error("Please add aadhar card");
        return;
      } else if (!panFile) {
        toast.error("Please add pan card");
        return;
      }

      if (!isSubmitted) {
        setIsSubmitted(true);
        let docIds = [];
        if (!aadharFile.file) {
          let aadharRes = await uploadFile(aadharFile, 0);
          docIds[0] = aadharRes.id;
        } else {
          docIds[0] = aadharFile.id;
        }
        if (!panFile.file) {
          let panRes = await uploadFile(panFile, 1);
          docIds[1] = panRes.id;
        } else {
          docIds[1] = panFile.id;
        }
        postSubcontractor({ ...payload, docs: docIds })
          .then((res) => {
            toast.success(
              `Sub-Contractor is ${isEditing ? "updated" : "added"}`
            );
            setIsSubmitted(false);
            handleClose();
            apiCall();
          })
          .catch((err) => {
            setIsSubmitted(false);
            toast.error(err.message);
          });
      }
    }
    return (
      <Modal
        show={show}
        onHide={handleClose}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header>
          <h1 class="headingfour">
            {isEditing === null ? "View" : isEditing ? "Edit" : "Add"}{" "}
            Sub-Contractors
          </h1>
          <img
            src={close_icon}
            alt="no_img"
            onClick={handleClose}
            style={{ cursor: "pointer" }}
          />
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmitForm} autoComplete="off">
            <Row>
              <Form.Group className="col-lg-6 col-md-12 mb-2">
                <Form.Label
                  className={isEditing === null ? "disabled-label" : ""}
                >
                  Name
                </Form.Label>
                <Form.Control
                  placeholder="Enter Name"
                  type="text"
                  className="inputfield"
                  name="name"
                  value={payload.name}
                  onChange={handleInputChange}
                  disabled={isEditing === null}
                  required
                />
              </Form.Group>
              <Form.Group className="col-lg-6 col-md-12 mb-2">
                <Form.Label
                  className={isEditing === null ? "disabled-label" : ""}
                >
                  Mobile Number
                </Form.Label>
                <Form.Control
                  placeholder="Enter Phone Number"
                  type="tel"
                  className="inputfield"
                  name="phone"
                  maxLength={10}
                  value={payload.phone}
                  onChange={handleInputChange}

                  onKeyDown={(e) => {
                    const allowedChars = /[0-9]/;
                    const allowedKeyCombinations = {
                      "Control+c": true,
                      "Control+v": true,
                      "Control+a": true,
                    };

                    // Allow Backspace and Tab keys without restrictions
                    if (
                      e.key === "Backspace" ||
                      e.key === "Tab" ||
                      e.key === "ArrowLeft" ||
                      e.key === "ArrowRight" ||
                      e.key === "Escape"
                    ) {
                      return;
                    }

                    if (
                      !(
                        allowedChars.test(e.key) ||
                        allowedKeyCombinations[
                          `${e.ctrlKey ? "Control+" : ""}${e.key.toLowerCase()}`
                        ]
                      )
                    ) {
                      e.preventDefault(); // Prevent input if key is not allowed
                    }
                  }}
                  onPaste={(e) => {
                    const pastedText = e.clipboardData
                      .getData("text/plain")
                      .replace(/\D/g, ""); // Remove non-numeric characters
                  }}

                  disabled={isEditing === null}
                  required
                  pattern="[0-9]{10}"
                />
              </Form.Group>
            </Row>
            <Row>
              <Form.Group className="col-lg-6 col-md-12 mb-2">
                <Form.Label
                  className={isEditing === null ? "disabled-label" : ""}
                >
                  Type
                </Form.Label>
                <Form.Select
                  defaultValue="Choose..."
                  className="inputfield"
                  name="category"
                  value={payload.category}
                  onChange={handleInputChange}
                  disabled={isEditing === null}
                  required
                >
                  <option hidden value="">
                    Select Type
                  </option>
                  {subContractorTypes.map((subContractorType) => {
                    return (
                      <option value={subContractorType.id}>
                        {subContractorType.name}
                      </option>
                    );
                  })}
                </Form.Select>
              </Form.Group>
              <Form.Group className="col-lg-6 col-md-12 mb-2">
                <Form.Label className={isEditing === null ? "disabled-label" : ""}>
                  Centre
                </Form.Label>
                <Form.Select
                  className="inputfield"
                  name="centre"
                  value={payload.centre}
                  onChange={handleInputChange}
                  disabled={isEditing === null}
                  required
                >
                  <option hidden value="">
                    Select Centre
                  </option>
                  {CENTRE_OPTIONS.map((c) => (
                    <option key={c.value} value={c.value}>
                      {c.label}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Row>

            <Row>
              <Form.Group
                className="col-lg-12 col-md-12 mb-2"
                controlId="formGridEmail"
              >
                <Form.Label
                  className={isEditing === null ? "disabled-label" : ""}
                >
                  Address
                </Form.Label>
                <Form.Control
                  placeholder="Enter Address"
                  type="text"
                  className="inputfield"
                  name="address"
                  value={payload.address}
                  onChange={handleInputChange}
                  disabled={isEditing === null}
                  required
                />
              </Form.Group>
            </Row>

            <Row className="mb-2">
              <Form.Group as={Col} className="col-md-12">
                <Form.Label
                  className={isEditing === null ? "disabled-label" : ""}
                >
                  Description
                </Form.Label>
                <Form.Control
                  as="textarea"
                  rows={2}
                  className="inputfield"
                  placeholder="Enter Description"
                  name="description"
                  value={payload.description}
                  onChange={handleInputChange}
                  disabled={isEditing === null}
                  required
                />
              </Form.Group>
            </Row>

            <Row className="mb-2">
              <Form.Group className="col-md-12">
                <Form.Label>
                  {isEditing !== null && "Add "}Aadhar Card
                </Form.Label>
                {isEditing === null ? (
                  <div className="d-flex justify-content-start align-items-center gap-3">
                    <div className="active-links">
                      <a
                        class="footer_link"
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          setFileLinks([selectSubContractor.docs?.[0]]);
                          setShowDoc(true);
                        }}
                      >
                        View file
                      </a>
                    </div>
                  </div>
                ) : (
                  <div className="d-flex justify-content-start align-items-center gap-3">
                    <div>
                      <input
                        type="file"
                        id="aadhar_file"
                        class="inputfile"
                        onChange={(event) => {
                          setAadharFile(event.target.files[0]);
                        }}
                        accept="image/*"
                      />
                      <label
                        for="aadhar_file"
                        class="add_employee_btn d-flex flex-row"
                        style={{ cursor: "pointer" }}
                      >
                        <span>
                          {aadharFile?.file
                            ? aadharFile.file?.split("/").at(-1)
                            : `${aadharFile?.name ?? "Upload File"}`}
                        </span>
                      </label>
                    </div>
                  </div>
                )}
              </Form.Group>
            </Row>
            <Row className="mb-4">
              <Form.Group className="col-md-12 pb-5">
                <Form.Label>{isEditing !== null && "Add "} Pan Card</Form.Label>
                {isEditing === null ? (
                  <div className="d-flex justify-content-start align-items-center gap-3">
                    <div className="active-links">
                      <a
                        class="footer_link"
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          setFileLinks([selectSubContractor.docs?.[1]]);
                          setShowDoc(true);
                        }}
                      >
                        View file
                      </a>
                    </div>
                  </div>
                ) : (
                  <div className="d-flex justify-content-start align-items-center gap-3">
                    <div>
                      <input
                        type="file"
                        id="pan_file"
                        class="inputfile"
                        onChange={(event) => {
                          setPanFile(event.target.files[0]);
                        }}
                        accept="image/*"
                      />
                      <label
                        for="pan_file"
                        class="add_employee_btn d-flex flex-row"
                        style={{ cursor: "pointer" }}
                      >
                        <span>
                          {panFile?.file
                            ? panFile.file?.split("/").at(-1)
                            : `${panFile?.name ?? "Upload File"}`}
                        </span>
                      </label>
                    </div>
                  </div>
                )}
              </Form.Group>
            </Row>
            <hr />

            {isEditing !== null && (
              <div className="d-flex justify-content-start align-items-center gap-2 pt-2">
                <input
                  type="button"
                  value="Cancel"
                  className="outline_btn"
                  onClick={handleClose}
                ></input>
                <input
                  type="submit"
                  value="Submit"
                  className="signup_button"
                ></input>
              </div>
            )}
          </Form>
          <DocumentViewModal
            show={showDoc}
            onHide={() => {
              setShowDoc(false);
              setFileLinks(null);
            }}
            aria-labelledby="contained-modal-title-vcenter"
            centered
            dialogClassName="custom-modal-xl"
            handleCloseView={() => {
              setShowDoc(false);
              setFileLinks(null);
            }}
            links={fileLinks}
          />
        </Modal.Body>
      </Modal>
    );
  }

  return (
    <React.Fragment>
      <div className="banner-section">
        <div class="d-flex justify-content-between align-items-center">
          <div>
            <h4 className="headingfour">Sub-Contractors List</h4>
          </div>
          {showAddSubConList && (
            <div className="d-flex gap-2">
              <Custombuttons
                label={"Add Sub-Contractor"}
                buttonIcon={Add}
                className="add_employee_btn"
                onClick={() => {
                  setIsEditing(false);
                  handleShow();
                }}
              />
            </div>
          )}
        </div>
        <hr />

        <div className="banner-section-dashboard  mb-3">
          <div class="d-flex justify-content-between align-items-center mb-3 gap-2">
            <div>
              <Customsearch
                searchValue={searchValue}
                setSearchValue={setSearchValue}
              />
            </div>
            <div style={{ minWidth: "200px" }}>
              <Form.Select
                className="inputfield"
                value={centreFilter}
                onChange={(e) => setCentreFilter(e.target.value)}
              >
                <option value="">All Centres</option>
                {CENTRE_OPTIONS.map((c) => (
                  <option key={c.value} value={c.value}>
                    {c.label}
                  </option>
                ))}
              </Form.Select>
            </div>
            <div style={{ minWidth: "200px" }}>
              <Form.Select
                className="inputfield"
                value={typeFilter}
                onChange={(e) => setTypeFilter(e.target.value)}
              >
                <option value="">All Types</option>
                {(subContractorTypes || []).map((t) => (
                  <option key={t.id} value={t.id}>
                    {t.name}
                  </option>
                ))}
              </Form.Select>
            </div>
          </div>
          <div className="table_section">
            <div className="table-responsive">
              <table className="table table-bordered align-middle">
                <thead className="table_head_bg">
                  <tr>
                    <th scope="col">Name</th>
                    <th scope="col">Phone Number</th>
                    <th scope="col">Type</th>
                    <th scope="col">Centre</th>
                    <th scope="col" style={{width:'150px'}}>Address</th>
                    <th scope="col" style={{width:'150px'}}> Description</th>

                    <th scope="col"></th>
                  </tr>
                </thead>
                <tbody>
                  {tableData?.results.map((row) => {
                    return (
                      <tr>
                        <td>{row.name}</td>
                        <td>{row.phone}</td>
                        <td>{row.category.name}</td>
                        <td>{CENTRE_OPTIONS.find((c) => c.value === row.centre)?.label ?? "-"}</td>
                        <td>
                        <LightTooltip title={row.address} arrow placement="bottom">
                        <div className="table_text_overflow">
                          {row.address}
                          </div>
                          </LightTooltip>
                          </td>
                        <td>
                        <LightTooltip title={row.description} arrow placement="bottom">
                          <div className="table_text_overflow"> {row.description}</div>
                         </LightTooltip></td>
                        <td>
                          <div className="d-flex justify-content-center align-items-center gap-2">
                            <LightTooltip title="View" arrow placement="bottom">
                              <ViewIcon
                                style={{ color: "#008080" }}
                                className="edit_icon"
                                onClick={() => {
                                  setIsEditing(null);
                                  setSelectedSubContractor(row);
                                  handleShow();
                                }}
                              />
                            </LightTooltip>
                            <LightTooltip title="Edit" arrow placement="bottom">
                              <EditIcon
                                style={{ color: "#008080" }}
                                className="edit_icon"
                                onClick={() => {
                                  setSelectedSubContractor(row);
                                  setIsEditing(true);
                                  handleShow();
                                }}
                              />
                            </LightTooltip>
                            <LightTooltip
                              title="Delete"
                              arrow
                              placement="bottom"
                            >
                              <DeleteIcon
                                onClick={() => {
                                  setSelectedSubContractor(row);
                                  handleDeleteShow();
                                }}
                                style={{ color: "#008080", fontSize: "20px" }}
                                className="edit_icon"
                              />
                            </LightTooltip>
                          </div>
                        </td>
                      </tr>
                    );
                  })}
                  {tableData?.count === 0 && (
                    <tr>
                      <td colSpan={7} className="text-center">
                        No data found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
          <Custompagenation data={tableData} setData={setTableData} />
          <AddSubContractorModal />

          <Modal
            show={deleteshow}
            onHide={handleDeleteClose}
            size="md"
            aria-labelledby="contained-modal-title-vcenter"
            centered
          >
            <Modal.Body className="deletebody">
              <div>
                <div className="">
                  <ListGroup className="list-group-flush">
                    <ListGroup.Item>
                      <div className="media d-flex">
                        <img
                          className="align-self-start mr-3"
                          style={{
                            height: "40px",
                            width: "40px",
                          }}
                          src={cancel}
                          alt="no_img"
                        />
                        <div
                          className="media-body ms-3"
                          style={{
                            position: "relative",
                          }}
                        >
                          <h5 className="mt-0 alerts-heading text-start">
                            Are you sure?
                          </h5>
                          <p className="text-start">
                            Do you really want to delete these records ? This
                            process cannot be undone
                          </p>
                        </div>
                      </div>
                    </ListGroup.Item>
                    <ListGroup.Item className="d-flex justify-content-end">
                      <div className="d-flex justify-content-end pt-1 pb-1 gap-2">
                        <input
                          type="button"
                          value="Cancel"
                          className="outline_btn"
                          onClick={handleDeleteClose}
                        ></input>
                        <input
                          type="button"
                          value="Delete"
                          className="delete_button"
                          ref={deleteButtonRef}
                          onClick={() => {
                            postSubcontractor({
                              id: selectSubContractor?.id,
                              name: selectSubContractor?.name,
                              phone: selectSubContractor?.phone,
                              address: selectSubContractor?.address,
                              description: selectSubContractor?.description,
                              category: selectSubContractor?.category?.id,
                              centre: selectSubContractor?.centre,
                              docs: getIds(selectSubContractor?.docs),
                              active: false,
                            })
                              .then((res) => {
                                toast.success("Subcontractor is deleted");
                                handleDeleteClose();
                                apiCall();
                              })
                              .catch((err) => {
                                toast.error(err.message);
                              });
                          }}
                        ></input>
                      </div>
                    </ListGroup.Item>
                  </ListGroup>
                </div>
              </div>
            </Modal.Body>
          </Modal>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Subcontractorslist;
